module.exports = __webpack_public_path__ + "img/0.7ml.0b6d0c1b.png";